import { useState, useEffect } from "react";
import { GenerateGeom } from "src/managers/GenerateGeom";


export function MitPatt(props: { pattern: string, opacity?: number }) {
   let [imgUrl, setImgUrl] = useState<string>("");

   useEffect(() => {
      GenerateGeom.getEveryMitPattern(props.pattern, (url) => {
         setImgUrl(url);
      });
   }, [props.pattern])

   return (
      <div style={{ width: "20px", height: "20px", backgroundColor: "white", marginLeft: "2px", marginRight: "0px", borderRadius: "3px", display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden", padding: "2px" }}>
         <div style={{ width: "100%", height: "100%", backgroundImage: `url(${imgUrl})`, backgroundSize: "cover", opacity: props.opacity ?? 1 }}></div>
      </div>
   )
}